import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getEmailLogs = async () => {
  const { data } = await axios.get(`${api_base_url}/Configuration/EmailLogs`);
  return data;
};
export const getEmailLogsDetails = async (emailActivityId) => {
  const { data } = await axios.get(
    `${api_base_url}/Configuration/EmailLogsDetails/${Number(emailActivityId)}`
  );
  return data;
};

export const requeueEmail = async (emailActivity) => {
  return await axios.put(`${api_base_url}/Email/EmailRequeuer`, {
    ...emailActivity,
  });
};
